/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown> }} Spaces_Scheduled_Sync_Every_HoursInputs */



/**
* | output |
* | --- |
* | "Every {hours} h" |
*
* @param {Spaces_Scheduled_Sync_Every_HoursInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_every_hours = /** @type {((inputs: Spaces_Scheduled_Sync_Every_HoursInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_Every_HoursInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle ${i?.hours} Std.`)
	return /** @type {LocalizedString} */ (`Every ${i?.hours} h`)
});